// Server
const subDir = 'sparepart360/';
// const subDir = 'Swatti_Autos/';

export default subDir;
